module.exports = __webpack_public_path__ + "img/icon-featherchevron-down.aa3db022.svg";